import * as yup from 'yup';

import { confirmPasswordSchema } from '@/utils/validation/schemas';

export const validationSchema = yup.object().shape({
  oldPassword: yup
    .string()
    .required('Password is required'),
}).concat(confirmPasswordSchema);
